var _pattern, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssimilationNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 112",
    fill: "none",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "skin",
    width: 17,
    height: 23,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 3 7-1m-2 8 6 1m-9 7 4-1",
    stroke: "#18291d",
    strokeOpacity: 0.45,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 4 2 5m-9 5 1 4",
    stroke: "#d1c997",
    strokeOpacity: 0.28,
    strokeWidth: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "plate-contacts",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 112,
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v112H0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m266 69 8 2 5-2-1 7-7 1-5-3Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#plate-contacts)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1136 0-13 18 6 12-13 17 3 13-12 12 4 9",
    stroke: "#080e0b",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.0 1.0L1129.0 4.6L1126.1 8.6L1124.6 13.0L1124.5 17.4L1124.5 21.6L1125.0 25.7L1126.0 29.6L1127.0 33.4L1127.5 37.2L1127.4 40.9L1127.0 44.7L1126.2 48.6L1124.6 52.8L1121.6 57.1L1117.3 61.5L1111.8 66.4L1111.8 66.4L1109.2 68.4L1106.5 70.2L1103.7 71.7L1100.7 73.0L1097.8 74.4L1094.8 75.9L1091.7 77.4L1088.5 78.9L1085.3 80.6L1082.1 82.6L1078.8 85.0L1075.5 87.7L1072.1 90.7L1068.7 94.2L1065.4 98.3L1062.0 103.0L1062.0 103.0L1065.7 98.6L1069.3 94.8L1072.8 91.4L1076.2 88.6L1079.6 86.1L1083.0 84.2L1086.3 82.5L1089.5 80.9L1092.6 79.4L1095.8 78.2L1098.9 77.1L1102.0 75.9L1105.0 74.5L1108.0 73.0L1111.1 71.4L1114.2 69.6L1114.2 69.6L1120.3 64.6L1124.7 59.6L1128.0 54.8L1130.5 50.2L1132.0 45.6L1132.5 41.1L1132.2 36.8L1131.8 32.6L1131.4 28.6L1131.0 24.7L1130.4 21.0L1129.9 17.4L1130.3 13.8L1130.8 10.1L1131.4 5.9L1133.0 1.0Z",
    fill: "#02425f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.0 1.0L1129.0 4.6L1126.1 8.6L1124.6 13.0L1124.5 17.4L1124.5 21.6L1125.0 25.7L1126.0 29.6L1127.0 33.4L1127.5 37.2L1127.4 40.9L1127.0 44.7L1126.2 48.6L1124.6 52.8L1121.6 57.1L1117.3 61.5L1111.8 66.4L1111.8 66.4L1109.2 68.4L1106.5 70.2L1103.7 71.7L1100.7 73.0L1097.8 74.4L1094.8 75.9L1091.7 77.4L1088.5 78.9L1085.3 80.6L1082.1 82.6L1078.8 85.0L1075.5 87.7L1072.1 90.7L1068.7 94.2L1065.4 98.3L1062.0 103.0L1062.0 103.0L1065.7 98.6L1069.3 94.8L1072.8 91.4L1076.2 88.6L1079.6 86.1L1083.0 84.2L1086.3 82.5L1089.5 80.9L1092.6 79.4L1095.8 78.2L1098.9 77.1L1102.0 75.9L1105.0 74.5L1108.0 73.0L1111.1 71.4L1114.2 69.6L1114.2 69.6L1120.3 64.6L1124.7 59.6L1128.0 54.8L1130.5 50.2L1132.0 45.6L1132.5 41.1L1132.2 36.8L1131.8 32.6L1131.4 28.6L1131.0 24.7L1130.4 21.0L1129.9 17.4L1130.3 13.8L1130.8 10.1L1131.4 5.9L1133.0 1.0Z",
    fill: "url(#skin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.0 30.0L1132.3 34.6L1139.5 37.1L1146.3 37.7L1152.6 37.4L1158.5 36.3L1164.0 34.4L1169.4 31.7L1174.5 28.7L1179.7 25.5L1185.0 22.4L1190.5 19.3L1196.2 16.4L1202.3 14.0L1208.9 12.2L1216.1 11.1L1224.0 11.0L1224.0 11.0L1216.1 10.8L1208.8 11.6L1202.1 13.3L1195.8 15.5L1189.9 18.1L1184.3 21.1L1179.0 24.3L1173.7 27.3L1168.5 30.0L1163.2 32.3L1157.8 34.1L1152.3 35.2L1146.4 35.3L1140.1 34.3L1133.1 32.4L1125.0 30.0Z",
    fill: "#02425f",
    stroke: "#02425f",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.0 30.0L1132.3 34.6L1139.5 37.1L1146.3 37.7L1152.6 37.4L1158.5 36.3L1164.0 34.4L1169.4 31.7L1174.5 28.7L1179.7 25.5L1185.0 22.4L1190.5 19.3L1196.2 16.4L1202.3 14.0L1208.9 12.2L1216.1 11.1L1224.0 11.0L1224.0 11.0L1216.1 10.8L1208.8 11.6L1202.1 13.3L1195.8 15.5L1189.9 18.1L1184.3 21.1L1179.0 24.3L1173.7 27.3L1168.5 30.0L1163.2 32.3L1157.8 34.1L1152.3 35.2L1146.4 35.3L1140.1 34.3L1133.1 32.4L1125.0 30.0Z",
    fill: "url(#skin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.0 64.0L1120.3 67.3L1128.3 69.4L1135.9 70.0L1143.1 69.6L1149.8 68.6L1156.2 67.1L1162.2 65.1L1167.8 62.9L1173.3 60.9L1178.6 59.2L1183.8 57.8L1188.8 56.7L1193.8 56.3L1198.9 56.8L1204.0 58.4L1209.4 61.0L1209.4 61.0L1214.2 64.1L1218.1 67.2L1221.3 70.3L1223.8 73.3L1225.9 76.2L1227.8 79.0L1229.3 81.7L1230.6 84.4L1231.9 87.0L1233.3 89.6L1235.0 92.0L1236.9 94.4L1239.2 96.7L1242.1 98.9L1245.7 101.0L1250.0 103.0L1250.0 103.0L1245.8 100.8L1242.4 98.6L1239.6 96.3L1237.4 94.0L1235.6 91.6L1234.2 89.1L1232.9 86.5L1231.7 83.9L1230.4 81.1L1229.0 78.3L1227.4 75.3L1225.3 72.2L1222.6 69.1L1219.3 65.9L1215.4 62.5L1210.6 59.0L1210.6 59.0L1204.9 56.1L1199.3 54.6L1193.9 54.0L1188.5 54.2L1183.1 55.0L1177.8 56.5L1172.4 58.4L1166.9 60.3L1161.2 62.1L1155.3 63.8L1149.2 65.3L1142.8 66.5L1135.9 66.8L1128.6 66.6L1120.7 65.8L1112.0 64.0Z",
    fill: "#4e0202",
    stroke: "#4e0202",
    strokeWidth: 0.65,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.0 64.0L1120.3 67.3L1128.3 69.4L1135.9 70.0L1143.1 69.6L1149.8 68.6L1156.2 67.1L1162.2 65.1L1167.8 62.9L1173.3 60.9L1178.6 59.2L1183.8 57.8L1188.8 56.7L1193.8 56.3L1198.9 56.8L1204.0 58.4L1209.4 61.0L1209.4 61.0L1214.2 64.1L1218.1 67.2L1221.3 70.3L1223.8 73.3L1225.9 76.2L1227.8 79.0L1229.3 81.7L1230.6 84.4L1231.9 87.0L1233.3 89.6L1235.0 92.0L1236.9 94.4L1239.2 96.7L1242.1 98.9L1245.7 101.0L1250.0 103.0L1250.0 103.0L1245.8 100.8L1242.4 98.6L1239.6 96.3L1237.4 94.0L1235.6 91.6L1234.2 89.1L1232.9 86.5L1231.7 83.9L1230.4 81.1L1229.0 78.3L1227.4 75.3L1225.3 72.2L1222.6 69.1L1219.3 65.9L1215.4 62.5L1210.6 59.0L1210.6 59.0L1204.9 56.1L1199.3 54.6L1193.9 54.0L1188.5 54.2L1183.1 55.0L1177.8 56.5L1172.4 58.4L1166.9 60.3L1161.2 62.1L1155.3 63.8L1149.2 65.3L1142.8 66.5L1135.9 66.8L1128.6 66.6L1120.7 65.8L1112.0 64.0Z",
    fill: "url(#skin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130 9c-5 25 14 35-19 58s-33 23-41 31",
    stroke: "#17506a",
    strokeWidth: 0.8,
    opacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118 55c-34 3-15-30-49-33M1095 81c-29-17-45 16-64 3M1189 65c-3-20 15-31 10-46M1192 18c-18-8-12-13-23-15",
    stroke: "#02425f",
    strokeWidth: 1.7,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230 81c19-2 21-18 37-16M1149 46c6-24 20-22 19-40M1118 44c-21 1-32-9-32-22",
    stroke: "#4e0202",
    strokeWidth: 1.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275 15-7 18 10 19-9 13",
    stroke: "#0a110b",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.0 24.0L275.9 29.0L278.0 32.8L279.4 36.3L279.7 40.1L279.0 44.0L277.9 48.1L276.6 52.5L275.2 57.0L273.8 61.6L272.7 66.3L272.4 71.1L273.2 76.0L275.1 81.0L278.3 86.0L283.2 91.0L290.0 96.0L290.0 96.0L283.5 90.6L278.9 85.5L276.0 80.5L274.5 75.7L274.3 71.1L274.7 66.6L275.8 62.2L277.3 57.8L279.2 53.4L281.0 49.1L282.2 44.7L282.9 40.3L282.8 35.8L281.6 31.1L278.5 26.9L273.0 24.0Z",
    fill: "#02425f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.0 24.0L275.9 29.0L278.0 32.8L279.4 36.3L279.7 40.1L279.0 44.0L277.9 48.1L276.6 52.5L275.2 57.0L273.8 61.6L272.7 66.3L272.4 71.1L273.2 76.0L275.1 81.0L278.3 86.0L283.2 91.0L290.0 96.0L290.0 96.0L283.5 90.6L278.9 85.5L276.0 80.5L274.5 75.7L274.3 71.1L274.7 66.6L275.8 62.2L277.3 57.8L279.2 53.4L281.0 49.1L282.2 44.7L282.9 40.3L282.8 35.8L281.6 31.1L278.5 26.9L273.0 24.0Z",
    fill: "url(#skin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.0 54.0L277.6 57.8L283.7 60.0L289.2 61.1L294.1 61.5L298.5 61.4L302.4 60.8L305.9 59.7L309.2 58.5L312.3 57.4L315.4 56.3L318.4 55.5L321.6 54.9L325.1 54.9L328.9 55.4L333.2 56.8L338.0 59.0L338.0 59.0L333.3 56.6L329.0 55.1L325.2 54.3L321.6 54.2L318.3 54.6L315.1 55.3L312.0 56.4L308.8 57.5L305.5 58.4L302.1 59.2L298.3 59.7L294.1 59.9L289.5 59.4L284.2 58.1L278.2 56.2L271.0 54.0Z",
    fill: "#02425f",
    stroke: "#02425f",
    strokeWidth: 0.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.0 54.0L277.6 57.8L283.7 60.0L289.2 61.1L294.1 61.5L298.5 61.4L302.4 60.8L305.9 59.7L309.2 58.5L312.3 57.4L315.4 56.3L318.4 55.5L321.6 54.9L325.1 54.9L328.9 55.4L333.2 56.8L338.0 59.0L338.0 59.0L333.3 56.6L329.0 55.1L325.2 54.3L321.6 54.2L318.3 54.6L315.1 55.3L312.0 56.4L308.8 57.5L305.5 58.4L302.1 59.2L298.3 59.7L294.1 59.9L289.5 59.4L284.2 58.1L278.2 56.2L271.0 54.0Z",
    fill: "url(#skin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 64c-26-1-19 22-41 26M281 39c21 0 26-14 36-15",
    stroke: "#4e0202",
    strokeWidth: 1.5,
    opacity: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m266 74 5 3 7-1",
    stroke: "#080e0b",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266 72 5 3 7-1",
    stroke: "#928568",
    strokeOpacity: 0.65,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273 75-2 6",
    stroke: "#9c9971",
    strokeOpacity: 0.65,
    strokeWidth: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssimilationNavbar);
export default __webpack_public_path__ + "static/media/assimilation-navbar.6c03255f3e1398de264f46004fd73eb9.svg";
export { ForwardRef as ReactComponent };